module.exports = __webpack_public_path__ + "static/media/5.87e37133.jpg";